import {
    FETCH_CORRESPONDENT_LIST_SUCCESS,
    FETCH_CORRESPONDENT_LIST_FAILURE,
    DELETE_CORRESPONDENT_ENTITY_SUCCESS,
    DELETE_CORRESPONDENT_ENTITY_FAILURE,
    ENABLE_CORRESPONDENT_SUCCESS,
    ENABLE_CORRESPONDENT_FAILURE
} from './action';
const initialState = {
    correspondentList: [],
    correspondentListError: [],
    deleteCorrespondentSuccess: [],
    deleteCorrespondentFailure: [],
    enableCorrespondentSuccess: [],
    enableCorrespondentFailure: []
}
const CorrespondentListReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CORRESPONDENT_LIST_SUCCESS:
            return state = {
                ...state,
                correspondentList: action.data
            }
        case FETCH_CORRESPONDENT_LIST_FAILURE:
            return state = {
                ...state,
                correspondentListError: action.error
            }
        case DELETE_CORRESPONDENT_ENTITY_SUCCESS:
            return state = {
                ...state,
                deleteCorrespondentSuccess: action.data
            }
        case DELETE_CORRESPONDENT_ENTITY_FAILURE:
            return state = {
                ...state,
                deleteCorrespondentFailure: action.data
            }
        case ENABLE_CORRESPONDENT_SUCCESS:
            return state = {
                ...state,
                enableCorrespondentSuccess: action.data
            }
        case ENABLE_CORRESPONDENT_FAILURE:
            return state = {
                ...state,
                enableCorrespondentFailure: action.data
            }
        default: return state
    }
    // return state;
};

export default CorrespondentListReducer; 